import React from 'react';
import './ComingSoonPage.css';

const ComingSoonPage = ({ title }) => {
  return (
    <section className="coming-soon section">
      <div className="container">
        <div className="coming-soon-content">
          <h2 className="coming-soon-title">{title}</h2>
          <p className="coming-soon-message">More info coming soon!</p>
        </div>
      </div>
    </section>
  );
};

export default ComingSoonPage;
